import { render, staticRenderFns } from "./CenterList.vue?vue&type=template&id=534840e5&scoped=true"
import script from "./CenterList.vue?vue&type=script&lang=js"
export * from "./CenterList.vue?vue&type=script&lang=js"
import style0 from "./CenterList.vue?vue&type=style&index=0&id=534840e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534840e5",
  null
  
)

export default component.exports